import React from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import styles from "./ViewToggle.module.css";

/**
 * ViewToggle
 *
 * A small, controlled two-state toggle to switch between "All View" and "My View".
 * - Controlled via the `mode` prop.
 * - Calls `onChange("all" | "mine")` when the user clicks.
 * - You can disable the "My View" button via `disableMine` (e.g., when partner isn't known yet).
 * - Size defaults to "sm" but you can pass "lg" as needed.
 */

// after
export type ViewMode = "all" | "myView";

export interface ViewToggleProps {
  mode: ViewMode;
  onChange: (next: ViewMode) => void;
  disableMine?: boolean;
  size?: "sm" | "lg";
  className?: string;          // for outer ButtonGroup
  allLabel?: string;           // default: "All View"
  locationLabel?: string;      // default: "My location"
  mineLabel?: string;          // default: "My View"
  ariaLabel?: string;          // default: "View mode"
}

const ViewToggle: React.FC<ViewToggleProps> = ({
  mode,
  onChange,
  disableMine = false,
  size = "sm",
  className,
  allLabel = "All View",
  locationLabel = "My Office",
  mineLabel = "My View",
  ariaLabel = "View mode",
}) => {
  return (
    <ButtonGroup
      className={`${styles.viewToggleGroup} ${className ?? ""}`}
      aria-label={ariaLabel}
    >
      <Button
        className={`${styles.viewToggleBtn} ${
          mode === "all" ? styles.viewToggleBtnActive : ""
        }`}
        size={size}
        onClick={() => onChange("all")}
      >
        {allLabel}
      </Button>
      <Button
        className={`${styles.viewToggleBtn} ${
          mode === "myView" ? styles.viewToggleBtnActive : ""
        }`}
        size={size}
        onClick={() => onChange("myView")}
        disabled={disableMine}
        title={disableMine ? "No filters available" : undefined}
      >
        {mineLabel}
      </Button>
    </ButtonGroup>
  );
};

export default ViewToggle;
